import { Component } from '@angular/core';

@Component({
  selector: 'app-template-evaluation-client',
  templateUrl: './template-evaluation-client.component.html',
  styleUrls: ['./template-evaluation-client.component.css']
})
export class TemplateEvaluationClientComponent {

}
